import React, { useEffect, useState } from 'react'
import styles from './login.module.css'
import { useLocation, useNavigate } from 'react-router-dom'
import { CircularProgress, } from '@mui/material';
import { ArrowIcon, BackArrowIcon, LogoIcon } from '../../../svg';
import { useDispatch } from 'react-redux';
import Toastify from '../../helper/Toastify';
import { unwrapResult } from '@reduxjs/toolkit';
import { verifyOtp } from '../../redux/loginSlice';
import api from '../../helper/Api';

const OtpVerification = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const item = location?.state.values.email;


    const [loading, setLoading] = useState(false);
    const [otp, setOtp] = useState([]);
    const [error, setError] = useState(false);

    console.log('otp=======================', otp);

    const [countdown, setCountdown] = useState(300);
    const [isResendDisabled, setIsResendDisabled] = useState(true);

    // Reset OTP and countdown timer when modal opens
    useEffect(() => {
        setOtp(['']);
        setCountdown(300); // Reset countdown timer to 5 seconds for testing
        setIsResendDisabled(true);
    }, []);

    // Countdown logic
    useEffect(() => {
        if (countdown > 0) {
            const timer = setInterval(() => {
                setCountdown((prev) => prev - 1);
            }, 1000);

            // Clear interval when countdown ends
            return () => clearInterval(timer);
        } else if (countdown === 0) {
            setIsResendDisabled(false);
        }
    }, [countdown,]);

    // Resend OTP function
    const handleResendOtp = async () => {
        if (!isResendDisabled) {
            setCountdown(300); // Reset countdown timer to 5 seconds for testing
            setIsResendDisabled(true); // Disable the resend button immediately after clicking

            try {
                const response = await api.forgotPassword({ email: item });
                unwrapResult(response)
                Toastify.success('Otp sent successfully')
            } catch (err) {
                console.error("Error updating profile:", err?.message);
            }
        }
    };

    // Handle OTP input
    const handleInputChange = (e, index) => {
        const value = e.target.value;
        setOtp(value)
    };



    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
    };

    // Submit OTP
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const resultAction = await dispatch(verifyOtp({ otp: otp, email: item }));
            unwrapResult(resultAction);
            navigate("/resetPassword", { state: { item } });
        } catch (error) {
            if (error?.message?.includes("OTP got expired")) {
                Toastify.error("The OTP has expired. Please request a new one.");
                setIsResendDisabled(false);
            } else {
                setError("Invalid OTP or something went wrong.");
            }
        }
    };

    return (
        <div className={styles.container}>
            <div className={styles.main}>
                <div className={styles.mainContainer}>
                <LogoIcon/>
                </div>
                <div className={styles.login}>
                    <div className={styles.mobileViewLogin}>
                        <div className={styles.mobileLogoStyle}>
                            <h3>KINGSTER</h3>
                        </div>
                    </div>
                    <div className={styles.content}>
                    <div onClick={() => navigate('/forgotPassword')} stylle={{marginTop:"10px",display:"flex",alignItems:"center",}} className={styles.backArrowStyle}><BackArrowIcon /> <span className={styles.backToLogin}>Back</span></div>
                    {/* <div onClick={() => navigate('/forgotPassword')} className={styles.backArrow}><BackArrowIcon /><h3>Verify Email Address</h3></div> */}
                        <h3 style={{ marginTop: 40 }} className={styles.forgotPassword}>Verify Email Address</h3>
                        <p style={{ marginTop: 40 }}>We’ve sent a one-time password (OTP) to your email
                            at {item}. Please enter it below to verify.
                        </p>
                        {error && <div className={styles.errorText}>{error}</div>}
                        <div style={{ marginTop: 20 }}>
                            <label className={styles.label}>OTP</label>
                            <div className={styles.inputbox}>
                                <input
                                    type='email'
                                    // onBlur={handleBlur}
                                    value={otp}
                                    placeholder='Enter 4 digits OTP'
                                    name="otp"
                                    onChange={handleInputChange}
                                />
                            </div>
                            {/* {
                                errors.email && touched.email && <p style={{ color: "red", fontSize: "12px", textAlign: "left" }}>{errors.email}</p>
                            } */}
                        </div>
                        <div className={styles.google}>
                            <div className={styles.saveButtonStyle} onClick={handleSubmit} disabled={loading} style={{ marginTop: 30 }}>
                                {
                                    loading ?
                                        <CircularProgress size={25} thickness={4.5} sx={{ color: "#fff" }} />
                                        : "Verify"
                                } <ArrowIcon />
                            </div>
                        </div>
                        {/* <div className={styles.textStyle}>
                            Didn’t receive? <span className={styles.loginText} onClick={handleResendOtp}>Resend OTP</span>
                        </div>
                        <div className={styles.timerText}>
                            ({formatTime(countdown)})
                        </div> */}
                        <div className={styles.textStyle}>
                            {isResendDisabled ? (
                                <p>Resend OTP in {formatTime(countdown)}</p>
                            ) : (

                                <span className={styles.loginText}>
                                    <br />
                                    Didn't receive OTP?{" "}
                                    <span className={styles.loginText} onClick={handleResendOtp}>
                                        Resend
                                    </span>
                                </span>
                            )}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}



export default OtpVerification;
